import { useState } from "react";

const faqData = [
  {
    question: "How do you make holy water?",
    answer:
      "You boil the hell out of it. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },

  {
    question: "What's the best thing about Switzerland?",
    answer:
      "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },

  {
    question: "What do you call someone with no body and no nose?",
    answer:
      "Nobody knows. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "How do you make holy water?",
    answer:
      "You boil the hell out of it. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },

  {
    question: "What's the best thing about Switzerland?",
    answer:
      "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },

  {
    question: "What do you call someone with no body and no nose?",
    answer:
      "Nobody knows. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
];

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className=" min-h-screen bg-white px-4 xl:px-0 py-10 md:items-center flex">
      <div className="container mx-auto flex flex-col gap-4 md:gap-0 md:flex-row md:justify-between items-start">
        <div className="w-full lg:w-1/3">
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Frequently asked questions
          </h1>
          <p className="mt-6 md:mb-8 max-w-2xl text-lg leading-8 text-gray-600 ">
            Can’t find the answer you’re looking for? Reach out to our{" "}
            <span className="text-indigo-600 font-bold">
              <a href="mailto:contact@finai.com" className="hover:underline">
                customer support
              </a>
            </span>{" "}
            team.
          </p>
        </div>
        <div className="w-full max-w-2xl">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="mb-4 bg-white border-b border-gray-300 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full text-left p-4 font-medium text-gray-800 hover:bg-gray-50 flex items-center justify-between"
              >
                <span>{item.question}</span>
                <span className="ml-2 text-xl">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </button>

              <div
                className={`px-4 overflow-hidden transition-all duration-500 ${
                  activeIndex === index
                    ? "max-h-40 py-4 opacity-100"
                    : "max-h-0 py-0 opacity-0"
                }`}
              >
                <p className="text-gray-600">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FAQ;
